import React from 'react';
import TrueImpactText from 'shared/design-system/base/TrueImpactText';
import styled from 'styled-components';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';
import { IndicatorSectionKey } from '../ImpactIndicator/utils';

interface IndicatorSectionUnselectedProps {
  zIndex?: number;
  totalIndicators: number;
  sectionKey: IndicatorSectionKey;
  sectionName: string;
}

const StyledDiv = styled.div<{ zIndex?: number }>`
  padding: ${SPACERS.medium};
  padding-top: ${SPACERS.medium};
  padding-right: 123px;
  min-width: 240px;
  height: 80%;
  display: flex;
  flex-direction: column;
  min-width: 240px;
  .section-name {
    height: 87px;
  }
  .total-indicators {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
`;

const IndicatorSectionUnselected: React.FC<IndicatorSectionUnselectedProps> = ({
  zIndex,
  sectionKey,
  sectionName,
  totalIndicators,
}) => {
  return (
    <StyledDiv zIndex={zIndex}>
      <TrueImpactText
        variant="heading-label"
        color="blackBase"
        className="section-name"
      >
        {sectionName}
      </TrueImpactText>
      <div className="total-indicators">
        <TrueImpactText variant="display-large" color="greyBase">
          {totalIndicators}
        </TrueImpactText>
        <TrueImpactText variant="heading-label" color="greyBase">
          {totalIndicators === 1 ? 'INDICATOR' : 'INDICATORS'}
        </TrueImpactText>
      </div>
    </StyledDiv>
  );
};

export default IndicatorSectionUnselected;
